"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionItemDtoAttendanceStatusEnum = exports.InspectionItemDtoRegistrationTypeEnum = void 0;
exports.instanceOfInspectionItemDto = instanceOfInspectionItemDto;
exports.InspectionItemDtoFromJSON = InspectionItemDtoFromJSON;
exports.InspectionItemDtoFromJSONTyped = InspectionItemDtoFromJSONTyped;
exports.InspectionItemDtoToJSON = InspectionItemDtoToJSON;
exports.InspectionItemDtoToJSONTyped = InspectionItemDtoToJSONTyped;
var InspectionListingDetailsDto_1 = require("./InspectionListingDetailsDto");
var InspectionUserDto_1 = require("./InspectionUserDto");
/**
 * @export
 */
exports.InspectionItemDtoRegistrationTypeEnum = {
    PreRegistered: 'pre_registered',
    WalkIn: 'walk_in'
};
/**
 * @export
 */
exports.InspectionItemDtoAttendanceStatusEnum = {
    Pending: 'pending',
    Attended: 'attended',
    Unattended: 'unattended'
};
/**
 * Check if a given object implements the InspectionItemDto interface.
 */
function instanceOfInspectionItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('registrationType' in value) || value['registrationType'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('listingInspection' in value) || value['listingInspection'] === undefined)
        return false;
    return true;
}
function InspectionItemDtoFromJSON(json) {
    return InspectionItemDtoFromJSONTyped(json, false);
}
function InspectionItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'registrationType': json['registrationType'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'attendanceStatus': json['attendanceStatus'] == null ? undefined : json['attendanceStatus'],
        'createdAt': (new Date(json['createdAt'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'listingInspection': (0, InspectionListingDetailsDto_1.InspectionListingDetailsDtoFromJSON)(json['listingInspection']),
        'user': json['user'] == null ? undefined : (0, InspectionUserDto_1.InspectionUserDtoFromJSON)(json['user']),
    };
}
function InspectionItemDtoToJSON(json) {
    return InspectionItemDtoToJSONTyped(json, false);
}
function InspectionItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'registrationType': value['registrationType'],
        'name': value['name'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'attendanceStatus': value['attendanceStatus'],
        'createdAt': value['createdAt'].toISOString(),
        'notes': value['notes'],
        'listingInspection': (0, InspectionListingDetailsDto_1.InspectionListingDetailsDtoToJSON)(value['listingInspection']),
        'user': (0, InspectionUserDto_1.InspectionUserDtoToJSON)(value['user']),
    };
}
